module.exports = __webpack_public_path__ + "img/bar-chart-dark-01.8829a0d8.jpg";